import React from "react";

const ViewCategoryModal = ({ category, onClose }) => {
  //   console.log('ViewCategoryModal rendered, onClose:', onClose);

  const handleClose = () => {
    console.log("handleClose triggered");
    if (onClose) {
      onClose();
    } else {
      console.error("onClose is undefined!");
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg shadow-2xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 bg-green-50 border-b border-gray-100 rounded-t-2xl">
          <h2 className="text-xl font-bold text-gray-800">Category Details</h2>
          <button
            type="button"
            onClick={handleClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-green-100 text-gray-500 transition"
          >
            ✕
          </button>
        </div>

        <div className="p-6 space-y-5">
          {/* Image */}
          <div className="relative rounded-xl overflow-hidden h-56 bg-gray-100">
            <img
              src={category.image}
              alt={category.category}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            <span className="absolute bottom-3 left-3 bg-green-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
              Category
            </span>
          </div>

          {/* Category Name */}
          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">
              Category Name
            </p>
            <h3 className="text-base font-bold text-gray-800">
              {category.category}
            </h3>
          </div>

          {/* Description */}
          {category.description && (
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">
                Description
              </p>
              <p className="text-sm text-gray-700 leading-relaxed">
                {category.description}
              </p>
            </div>
          )}

          {/* Key Points */}
          {category.keyPoints?.length > 0 && (
            <div className="bg-green-50 rounded-xl p-4">
              <p className="text-xs font-semibold text-green-600 uppercase tracking-wide mb-3">
                Key Points
              </p>
              <ul className="space-y-2">
                {category.keyPoints.map((point, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-2 text-sm text-gray-700"
                  >
                    <span className="w-2 h-2 rounded-full bg-green-500 flex-shrink-0 mt-1.5" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            type="button"
            onClick={handleClose}
            className="w-full py-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCategoryModal;
